export default __webpack_public_path__ + "/dist/images/map.fb4e743b25674f4732f34a786f2d5c04.png";